<template>
    <div>
        <Nav></Nav>
        <AnaLoading way="Client" :show="pageloading"></AnaLoading>
        <div v-if="!pageloading">
        <b-container v-if="pageview">
            <PageHeader :linkto="'/Phone'" :linkttitle="'返回'" :title="productName"></PageHeader>

            <b-card no-body :header="'黃金號碼'" class="mb-2" border-variant="secondary" header-bg-variant="secondary"
                    header-text-variant="white">
                <div class="p-2 my-2">
                   <p> 以下數字前三碼不看，其他數字可以自由編排。<br>（EX:0912345678 最前面的091為前三碼，後面再把黃金號碼填上，就可以馬上拿著這組超級號碼去申請門號囉！）</p>


                    <div v-for="(item , index) in anaSubResult.listdata" v-bind:key="index"
                         class="border d-inline-flex rounded-pill p-1 px-3 mx-1 bg-primary text-white"  >{{ item.Number }}</div>
                </div>
            </b-card>
            <ResultCard v-for="(item , index) in anaSubResult.listdata" v-bind:key="index"  :title="item.wishname" :listdata="item.explantion" :resultname="'result'"></ResultCard>
        </b-container>
        <b-container v-else>
            <b-button class="mt-3" variant="primary" block to="/Phone">重新輸入電話號碼</b-button>
        </b-container>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import ResultCard from '@/components/ResultCard.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import {playSound} from '@/service/commuse'

export default {
  name: 'PhoneResult',
  components: {Nav,PageHeader,ResultCard,AnaLoading},
  data () {
    return {
      productName:'電話分析',
      formData: {},
      pageloading:false,
      puid:'5',
      masterTips:{
        status:true,
        videostatus:false,
        videosrc:'',
        tipswords:'以下數字前三碼不看，其他數字可以自由編排。（EX:0912345678 最前面的091為前三碼，後面再把黃金號碼填上，就可以馬上拿著這組超級號碼去申請門號囉！）',
      },
    }
  },
  computed:{
    ...mapState(['anaResult','profiledata','anaSubResult']),
    pageview:function () {return Object.keys(this.anaSubResult).length === 0 ? false: true;},

  },
  mounted(){
    this.loadingView()
  },
  methods: {

    loadingView(){
      setTimeout(()=>{
        if(this.pageview){
          playSound()
        }
        this.pageloading = false
      },2500)


    }

  }
}
</script>

<style scoped>

</style>
